import Vue from "vue";
import EquipmentTab from "@/views/EquipmentProfile/EquipmentTab.vue";

Vue.component("equipment-tab", EquipmentTab);
